<template>
    <div class="recStandard-result-page">
        <div class="title">查询结果</div>
        <div class="sub-title">
            <span class="condition">搜索条件：</span>
            <span class="catogory">{{ searchKey }}</span
            >；
            <span v-if="origin && dest" class="addr">{{ origin }}-{{ dest }}</span>
        </div>
        <div class="result">
            <div v-for="(item, index) in list" :key="index" class="item">
                <div class="main">
                    <div class="info box">
                        <div class="split-box header">
                            <div>物品名</div>
                            <div>收寄要求</div>
                        </div>
                        <div class="split-box content">
                            <div>{{ item.acceptCriteriaList[0].searchKey }}</div>
                            <div>{{ getRequireName(item.acceptCriteriaList[0].finalExpressRequireCode) || '--' }}</div>
                        </div>
                    </div>
                    <!-- <div class="way box">
                        <div class="header">运输方式</div>
                        <div class="content">
                            <span>陆运：{{ getRequireName(item.acceptCriteriaList[0].finalExpressRequireRoad) || '--' }}</span
                            ><span class="air-trans">空运：{{ getRequireName(item.acceptCriteriaList[0].finalExpressRequireAir) || '--' }}</span>
                        </div>
                    </div> -->
                    <div class="des box">
                        <div class="header">收寄说明</div>
                        <div v-if="!item.acceptCriteriaList[0].finalExpressInstructionsCopy">
                            {{ item.acceptCriteriaList[0].finalExpressInstructions || '暂无信息' }}
                        </div>
                        <div v-else class="des-detail">
                            {{ item.acceptCriteriaList[0].finalExpressInstructionsCopy
                            }}<span class="arr-r" @click="showMore(item.acceptCriteriaList[0])">展开更多</span>
                        </div>
                    </div>
                </div>
                <div
                    v-if="showSendBtn(item.acceptCriteriaList[0].finalExpressRequireRoad, item.acceptCriteriaList[0].finalExpressRequireAir)"
                    class="send"
                    @click="toShip()"
                >
                    立即寄件
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { jump } from '@/mixins/pageJump/'
import loginType from '@/constant/loginType'
import { urls } from '@/constant/paths'
import UIP from '@/util/uip.js'

export default {
    name: 'RecStandardRes',
    components: {},
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            list: [],
            origin: '',
            dest: '',
            searchKey: '',
            smallPro: false
        }
    },
    computed: {},
    created() {
        this.list = this.$route.params.list || []
        this.list.forEach(item => {
            const max = 85
            if (item.finalExpressInstructions && item.finalExpressInstructions.length > max) {
                item.finalExpressInstructionsCopy = `${item.finalExpressInstructions.slice(0, max)}...`
            } else {
                item.finalExpressInstructionsCopy = ''
            }
        })
        this.origin = this.$route.params.origin || ''
        this.dest = this.$route.params.dest || ''
        this.searchKey = this.$route.params.searchKey || ''
        this.search_type = this.$route.params.search_type || ''
        // eslint-disable-next-line no-undef
        wx.miniProgram.getEnv(res => {
            this.smallPro = !!res.miniprogram
        })
    },
    methods: {
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader'
        }),
        getRequireName(type) {
            return {
                ExpressRequireAllow: '可收寄',
                ExpressRequireProhibit: '不可收寄',
                ExpressRequireRestrict: '有条件收寄'
            }[type]
        },
        showMore(item) {
            item.finalExpressInstructionsCopy = ''
            this.list = [...this.list]
        },
        toShip() {
            // 神策埋点
            UIP.sensor.track('ShipmentStandardConsignorClick', {
                event_name: '收寄标准查询_立即寄件',
                search_type: this.search_type,
                goods_name: this.searchKey
            })
            this.setShowHeader(false) // 隐藏公共的头部
            if (this.smallPro) {
                setTimeout(() => {
                    // eslint-disable-next-line no-undef
                    wx.miniProgram.navigateTo({
                        url: '/pages/order/sending/order-home/order-home?type=normal', // 跳转回小程序的页面,传参id, 小程序onLoad函数接收参数即可
                        success: () => {
                            console.log('success')
                        },
                        fail: () => {
                            console.log('跳转回小程序的页面fail')
                        }
                    })
                }, 0)
            } else {
                const urlConfig = {
                    owfUrl: `/mobile/cn/sc/login?type=${loginType.WX_ORDER}`,
                    cxUrl: `${urls.MP_CHECK_TICKET}?type=${loginType.WX_ORDER}`
                }
                jump(urlConfig)
            }
        },
        showSendBtn(road = '', air = '') {
            return [road, air].some(item => item === 'ExpressRequireAllow' || item === 'ExpressRequireRestrict')
        }
    },
    watch: {}
}
</script>

<style lang="scss" scoped>
.recStandard-result-page {
    background: #f2f2f2;
    min-height: 100%;
    padding: 0.24rem;
    .title {
        font-size: 0.28rem;
        color: #222222;
    }
    .sub-title {
        margin-top: 0.06rem;
        font-size: 0.24rem;
        color: #333333;
        line-height: 0.34rem;
        .condition {
            color: #333333;
        }
        .catogory {
            color: #2a2a2a;
        }
        .addr {
            color: #2a2a2a;
        }
    }
    .result {
        .item {
            background: #ffffff;
            border-radius: 0.08rem;
            margin-top: 0.24rem;
            .main {
                padding-top: 0.2rem;
                padding-bottom: 0.24rem;
                border-bottom: solid 1px #dddddd;
            }
            .box {
                margin-bottom: 0.2rem;
                &:last-child {
                    margin-bottom: 0;
                }
                font-size: 0.26rem;
                color: #222222;
                letter-spacing: 0;
                padding: 0 0.24rem;
            }
            .header {
                font-size: 0.26rem;
                color: #999999;
                letter-spacing: 0;
            }
            .split-box {
                display: flex;
                div {
                    flex: 1;
                }
            }
            .send {
                height: 0.7rem;
                line-height: 0.7rem;
                font-size: 0.26rem;
                color: #cc3244;
                letter-spacing: 0;
                text-align: center;
            }
            .air-trans {
                margin-left: 0.5rem;
            }
            .des-detail {
                position: relative;
                .arr-r {
                    padding-right: 0.32rem;
                    position: relative;
                    font-size: 0.26rem;
                    color: #999999;
                    letter-spacing: 0;
                    &::after {
                        content: ' ';
                        transform: rotate(90deg);
                        position: absolute;
                        right: 0;
                        top: 50%;
                        width: 0.32rem;
                        height: 0.32rem;
                        margin-top: -0.16rem;
                        background-image: url('~@/assets/images/recStandard/icon-arr-r.png');
                        background-repeat: no-repeat;
                        background-position: right center;
                        background-size: 0.32rem;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/recStandard/result.vue